// extracted by mini-css-extract-plugin
export default {"section":"CreateBlog_section__BjXqn","control":"CreateBlog_control__TsnBF","actions":"CreateBlog_actions__CzIIy"};